import axios from "axios";

const CRM_TRACKING_ENDPOINT = "https://gatewaysistemas.com.br/gatewayApi/api/eventoscrm/evento";
const VISITOR_ID_KEY = "crm_visitor_id";
const SESSION_ID_KEY = "crm_session_id";
const EVENT_CACHE_PREFIX = "crm_event_cache";

const generateId = (prefix) => {
  const randomPart = Math.random().toString(36).slice(2, 10);
  const timePart = Date.now().toString(36);
  return `${prefix}_${timePart}_${randomPart}`;
};

const getStorage = (type) => {
  if (typeof window === "undefined") {
    return null;
  }

  return type === "local" ? window.localStorage : window.sessionStorage;
};

const getOrCreateStorageValue = (storageType, key, prefix) => {
  const storage = getStorage(storageType);

  if (!storage) {
    return generateId(prefix);
  }

  let value = storage.getItem(key);

  if (!value) {
    value = generateId(prefix);
    storage.setItem(key, value);
  }

  return value;
};

const getEventCacheKey = (eventType, eventName, dedupeKey) =>
  `${EVENT_CACHE_PREFIX}:${eventType}:${eventName}:${dedupeKey}`;

const wasEventRecentlyTracked = (eventType, eventName, dedupeKey, dedupeWindowMs) => {
  const storage = getStorage("session");

  if (!storage) {
    return false;
  }

  const cacheKey = getEventCacheKey(eventType, eventName, dedupeKey);
  const lastTrackedAt = storage.getItem(cacheKey);

  if (!lastTrackedAt) {
    return false;
  }

  return Date.now() - Number(lastTrackedAt) < dedupeWindowMs;
};

const markEventAsTracked = (eventType, eventName, dedupeKey) => {
  const storage = getStorage("session");

  if (!storage) {
    return;
  }

  const cacheKey = getEventCacheKey(eventType, eventName, dedupeKey);
  storage.setItem(cacheKey, String(Date.now()));
};

export const getVisitorId = () =>
  getOrCreateStorageValue("local", VISITOR_ID_KEY, "visitor");

export const getSessionId = () =>
  getOrCreateStorageValue("session", SESSION_ID_KEY, "session");

export const getDeviceType = () => {
  if (typeof window === "undefined") {
    return "unknown";
  }

  const width = window.innerWidth;

  if (width < 768) {
    return "mobile";
  }

  if (width < 1024) {
    return "tablet";
  }

  return "desktop";
};

export const trackCRMEvent = async ({
  eventType,
  eventName,
  metadata = {},
  userId = null,
  dedupeKey = null,
  dedupeWindowMs = 0,
}) => {
  if (typeof window === "undefined") {
    return false;
  }

  const effectiveDedupeKey = dedupeKey || window.location.href;

  if (
    dedupeWindowMs > 0 &&
    wasEventRecentlyTracked(eventType, eventName, effectiveDedupeKey, dedupeWindowMs)
  ) {
    return false;
  }

  const payload = {
    session_id: getSessionId(),
    visitor_id: getVisitorId(),
    user_id: userId,
    event_type: eventType,
    event_name: eventName,
    page_url: window.location.href,
    referrer: document.referrer || "",
    device_type: getDeviceType(),
    ip_address: null,
    user_agent: window.navigator.userAgent,
    metadata: JSON.stringify(metadata),
    created_at: new Date().toISOString(),
  };

  try {
    const response = await axios.post(CRM_TRACKING_ENDPOINT, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (dedupeWindowMs > 0) {
      markEventAsTracked(eventType, eventName, effectiveDedupeKey);
    }

    return Boolean(response?.data);
  } catch (error) {
    console.error("Erro ao enviar evento CRM:", error);
    return false;
  }
};
